// extracted by mini-css-extract-plugin
export default {"alert":"app-alerts_alert_qf4K1"};